<template>
  <div class="flex act-container">
    <div>
      <act-preview
        phoneHeaderFixed
        navigationBg="transparent"
        navigationTitle="积分兑换"
      >
        <div class="slot">
          <div class="header-img-wrapper redeem-upload prev-upload">
            <div class="upload-img" v-if="ruleForm.gameBgp" @click="toggleShow">
              <span class="hmicon icon-shangchuantupian1"></span>
            </div>
            <img class="header-img" :src="ruleForm.gameBgp" alt="" />
            <div
              class="empty"
              style="margin-top: 60px; font-size: 12px"
              v-if="!ruleForm.gameBgp"
            >
              还没有主图立即
              <el-button type="primary" size="mini" @click="toggleShow"
                >添加</el-button
              >
            </div>
          </div>
          <div
            class="preview-type-list"
            v-if="
              goodsSettingList.length && newIntegralExchangeState === 'open'
            "
          >
            <div class="type-title">商品分类</div>
            <template>
              <div
                class="type-item"
                v-for="(v, i) in goodsSettingList"
                :key="i"
                v-show="v.indexpageShowState==='yes'"
              >
                <div class="img-wrapper">
                  <img :src="v.previewImgPath" alt="" class="img" />
                </div>
              </div>
            </template>
          </div>
          <div class="preview-goods-list prev-upload">
            <div
              class="upload-img"
              v-if="ruleForm.goodsRuleModels.length"
              @click="addGoods"
            >
              <span
                class="hmicon icon-shangchuantupian1 icon-hao pointer"
              ></span>
            </div>
            <div class="empty" v-if="!ruleForm.goodsRuleModels.length">
              还没有商品立即
              <el-button type="primary" size="mini" @click="addGoods"
                >添加商品</el-button
              >
            </div>
            <template v-if="ruleForm.goodsRuleModels.length">
              <div
                class="goods-item flex"
                v-for="(v, i) in ruleForm.goodsRuleModels"
                :key="i"
              >
                <div class="delete-item" @click="deleteChild(i)">
                  <span class="hmicon hmicon icon-shanchu1 pointer"></span>
                </div>
                <div class="img-wrapper">
                  <img :src="v.prePic || v.wxshopskupic" alt="" />
                </div>
                <div class="flex-1 flex flex-column flex-between info-wrapper">
                  <div>
                    <div class="goods-name text-overflow-2">
                      {{ v.wxshopSpuName }}
                    </div>
                  </div>
                  <div
                    class="exchange-promition-wrapper"
                    v-if="v.specIdGroupName"
                  >
                    <span class="exchange-promition">
                      {{ v.specIdGroupName }}
                    </span>
                  </div>
                  <div class="flex item-center progress-wrapper">
                    <div
                      class="progress flex flex-between btn light"
                      :style="{
                        background: storeStyle.lightColor,
                      }"
                    >
                      <div
                        class="primary btn slide"
                        :style="{
                          width:
                            v.bargainTotalStockSum -
                            v.surplusStockSum +
                            (v.virtualExchangeNum /
                              (v.bargainTotalStockSum + v.virtualExchangeNum)) *
                              100 +
                            '%',
                        }"
                      ></div>
                      <div class="progress-info flex flex-between">
                        <span>已抢0</span>
                        <span>0%</span>
                      </div>
                    </div>
                    <div
                      class="percent"
                      v-show="ruleForm.restrictionsShowState === 'yes'"
                      v-if="v.eachPurchaseLimit"
                      :style="{ color: storeStyle.baseColor }"
                    >
                      每人限兑{{ v.eachPurchaseLimit }}件
                    </div>
                  </div>
                  <div class="flex">
                    <!-- <div class="flex-1">
                      库存1
                      <div class="flex-1 flex item-end flex-wrap">
                      <div class="" v-if="v.integralValue">
                        <span :style="{ color: storeStyle.baseColor }">
                          <strong>{{ v.integralValue }}积分</strong>
                        </span>
                        <span
                          v-if="v.integralPrice"
                          :style="{ color: storeStyle.baseColor }"
                          >+<strong>{{ v.integralPrice }}元</strong></span
                        >
                      </div>
                      <div v-if="v.wxshopPrice" class="origin-price">
                        原价{{ v.wxshopPrice }}元
                      </div>
                    </div>
                    </div> -->
                    <div class="flex-1 flex item-end flex-wrap">
                      <div class="" v-if="v.integralValue">
                        <span :style="{ color: storeStyle.baseColor }">
                          <strong>{{ v.integralValue }}积分</strong>
                        </span>
                        <span
                          v-if="v.integralPrice"
                          :style="{ color: storeStyle.baseColor }"
                          >+<strong>{{ v.integralPrice }}元</strong></span
                        >
                      </div>
                      <div v-if="v.wxshopPrice" class="origin-price">
                        原价{{ v.wxshopPrice }}元
                      </div>
                    </div>
                    <div>
                      <div
                        class="btn round"
                        :style="{ background: storeStyle.baseColor }"
                      >
                        立即兑换
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </act-preview>
    </div>
    <div class="add-goods-containers">
      <div class="act-wrapper">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="154px"
        >
          <div id="base">1.基本信息</div>
          <el-form-item label="活动标题" prop="gameName">
            <el-input
              style="width: 400px"
              size="small"
              class="mr10 ipt"
              v-model.trim="ruleForm.gameName"
              placeholder="请输入活动标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="区域选择">
            <el-select
              v-model="ruleForm.storeRegionId"
              placeholder="请选择大区"
              size="small"
              filterable
              clearable
              style="width: 300px;"
            >
              <el-option
                v-for="item in regionList"
                :key="item.id"
                :label="item.regionName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="活动时间段选择" prop="activityDate">
            <div v-if="type">
              开始时间：
              <el-date-picker
                :disabled="type == 'details'"
                v-model="ruleForm.activityDate[0]"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                placeholder="开始时间"
                size="small"
                class="mr10"
              >
              </el-date-picker>
            </div>
            <div v-if="type">
              结束时间：
              <el-date-picker
                size="small"
                :editable="false"
                v-model="ruleForm.activityDate[1]"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="'23:59:59'"
                placeholder="结束时间"
                :picker-options="pickerOptions0"
              >
              </el-date-picker>
            </div>
            <div v-if="!type">
              <el-date-picker
                :default-time="['00:00:00', '23:59:59']"
                v-model="ruleForm.activityDate"
                :picker-options="pickerOptions0"
                type="datetimerange"
                align="right"
                start-placeholder="活动开始时间"
                end-placeholder="活动结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
              ></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="活动分享文案" prop="gameShareContent">
            <el-input
              :maxlength="30"
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.gameShareContent"
              placeholder="请输入活动分享文案，30字以内"
            ></el-input>
          </el-form-item>
          <el-form-item label="主图：" prop="gameBgp">
            <my-upload
              field="file"
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="show"
              v-if="show"
              noCircle
              noSquare
              :width="750"
              :height="1334"
              :headers="{ 'X-Access-Token': $token }"
              :params="{ fileDir: 'mallDecoration' }"
              :url="$uploadUrl"
              img-format="png"
            ></my-upload>
            <el-button
              type="primary"
              size="small"
              :disabled="type === 'details'"
              v-show="!ruleForm.gameBgp"
              @click="toggleShow"
              >上传</el-button
            >
            <span class="form-tip">图片尺寸建议750x1334（最多上传一张）</span>
            <div class="priview" v-if="ruleForm.gameBgp">
              <img :src="ruleForm.gameBgp" alt="主图" />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="toggleShow">更换</el-button>
              </div>
            </div>
          </el-form-item>
          <div id="base">2.活动规则</div>
          <el-form-item
            label="是否在商城显示限购数"
            prop="restrictionsShowState"
          >
            <el-switch
              v-model="ruleForm.restrictionsShowState"
              active-text="显示"
              inactive-text="隐藏"
              active-value="yes"
              active-color="#13ce66"
              inactive-value="no"
            ></el-switch>
          </el-form-item>

          <el-form-item
            label="仅显示当前活动商品"
          >
            <el-switch
              v-model="ruleForm.qrCodeState"
              active-text="开启"
              inactive-text="关闭"
              active-value="yes"
              active-color="#13ce66"
              inactive-value="no"
              :disabled="type == 'details'"
            ></el-switch>
          </el-form-item>
        


          <el-form-item label="规则设置" prop="goodsRuleModels">
            <div
              class="flex batch flex-between mt10 item-center"
              v-if="type !== 'details'"
            >
              <div class="ml10">
                <el-button size="small" type="text" @click="addGoods"
                  >添加商品</el-button
                >
              </div>
              <div class="flex flex-center">
                <div @click="outputExcel" class="delete mr20 pointer">
                  <span class="delete-icon hmicon icon-daochu"></span>
                  导出模板
                </div>
                <div class="delete mr20 pointer open-file">
                  <span class="delete-icon hmicon icon-daoru"></span>
                  导入
                  <input
                    type="file"
                    @change="importf"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  />
                </div>
              </div>
            </div>
            <div class="form-item-tip primary">拖拽序号移动</div>
            <el-table
              :data="ruleForm.goodsRuleModels"
              row-key="wxshopSkuId"
              border
              stripe
              max-height="400"
              style="width: 100%"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
                class-name="my-handle move"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="seqNum"
                label="排序"
                width="120"
              >
                <template slot-scope="scope">
                  <el-input
                    maxlength="4"
                    @mousewheel.prevent.native
                    style="width: 80px"
                    v-model.trim="scope.row.seqNum"
                    size="small"
                    @input="
                      filterGt0OrFixed0('seqNum', scope.$index)
                    "
                    clearable
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsSn"
                label="商品货号"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="wxshopSpuName"
                label="商品名称"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="specIdGroupName"
                label="规格"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="列表图片"
                prop="prePic"
                width="120"
              >
                <template slot="header">
                  <el-popover
                    placement="top-start"
                    title="提示"
                    width="200"
                    trigger="hover"
                    content="上传图片大小750*750，支持图片jpg、png格式，不上传图片的时候默认读取商品主图图片"
                  >
                    <div slot="reference" class="flex flex-center">
                      列表图片
                      <span>
                        <i class="el-icon-question" style="fontsize: 20px"></i>
                      </span>
                    </div>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <div
                      class="flex goods-upload-btn"
                      @click="addGoodsImg(scope.row, 'prePic')"
                      v-if="!scope.row.prePic"
                    >
                      <div
                        style="margin-left: 0px"
                        class="
                          btn
                          flex flex-column flex-center
                          open-file
                          item-center
                        "
                      >
                        <div class="add-prize-img-wrapper">
                          <span class="hmicon icon-hao pointer"></span>
                        </div>
                        <span>添加图片</span>
                      </div>
                    </div>
                    <div v-else class="flex item-end priviews">
                      <el-image
                        class="img"
                        :src="scope.row.prePic"
                        alt="logo"
                        :preview-src-list="[scope.row.prePic]"
                      />
                      <div class="opreat-wrapper flex item-center flex-center">
                        <el-button
                          type="text"
                          @click="handleRemovePrePic(scope.$index, 'prePic')"
                          >删除</el-button
                        >
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                prop="stockNum"
                label="库存"
              >
              </el-table-column> -->
              <el-table-column
                header-align="center"
                align="center"
                prop="groupName"
                label="商品分类"
                width="140"
                v-if="newIntegralExchangeState === 'open'"
              >
                <template slot="header">
                  <div
                    slot="reference"
                    class="flex flex-center"
                    @click="openGoodsSetting"
                  >
                    商品分类
                    <span>
                      <i class="hmicon icon-xitong ml10"></i>
                    </span>
                  </div>
                </template>
                <!-- :disabled="type === 'details'" -->
                <template slot-scope="scope">
                  <el-select
                    clearable
                    size="small"
                    style="width: 100%"
                    v-model="scope.row.integralTypeId"
                    placeholder="无商品分类"
                  >
                    <el-option
                      :label="v.integralTypeName"
                      :value="v.id"
                      v-for="(v, i) in goodsSettingList"
                      :key="i"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="bargainTotalStockSum"
                label="活动库存"
                width="160"
              >
                <template slot="header">
                  <el-popover
                    placement="top-start"
                    title="提示"
                    width="200"
                    trigger="hover"
                    content="活动库存为必填"
                  >
                    <div slot="reference" class="flex flex-center">
                      <div class="wadwa">活动库存</div>

                      <span>
                        <i class="el-icon-question" style="fontsize: 20px"></i>
                      </span>
                    </div>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <el-input
                    :disabled="type === 'details'"
                    maxlength="30"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    v-model.trim="scope.row.bargainTotalStockSum"
                    size="small"
                    @input="
                      filterGt0OrFixed0('bargainTotalStockSum', scope.$index)
                    "
                    clearable
                    placeholder="活动库存"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="eachPurchaseLimit"
                label="单人限购"
                width="122"
              >
                <template slot="header">
                  <el-popover
                    placement="top-start"
                    title="提示"
                    width="200"
                    trigger="hover"
                    content="不填为不限购"
                  >
                    <div slot="reference">
                      单人限购
                      <span>
                        <i class="el-icon-question" style="font-size: 20px"></i>
                      </span>
                    </div>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <el-input
                    :disabled="type === 'details'"
                    maxlength="30"
                    @mousewheel.prevent.native
                    style="width: 70px"
                    v-model.trim="scope.row.eachPurchaseLimit"
                    size="small"
                    @input="
                      filterGt0OrFixed0('eachPurchaseLimit', scope.$index)
                    "
                    clearable
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="integralValue"
                label="兑换价值"
                width="300"
              >
                <template slot="header">
                  <el-popover
                    placement="top-start"
                    title="提示"
                    width="200"
                    trigger="hover"
                    content="积分为必填"
                  >
                    <div slot="reference" class="flex flex-center">
                      <div class="wadwa">兑换价值</div>
                      <span>
                        <i class="el-icon-question" style="font-size: 20px"></i>
                      </span>
                    </div>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <el-input
                    :disabled="type === 'details'"
                    maxlength="30"
                    @mousewheel.prevent.native
                    style="width: 80px"
                    v-model.trim="scope.row.integralValue"
                    size="small"
                    @input="filterGt0OrFixed0('integralValue', scope.$index)"
                    clearable
                  ></el-input
                  >积分+
                  <el-input
                    :disabled="type === 'details'"
                    maxlength="30"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    v-model.trim="scope.row.integralPrice"
                    size="small"
                    @input="filterGt0OrFixed2('integralPrice', scope.$index)"
                    clearable
                  ></el-input
                  >元
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="virtualExchangeNum"
                label="虚拟兑换人数"
                width="110"
              >
                <template slot-scope="scope">
                  <el-input
                    :disabled="type === 'details'"
                    maxlength="30"
                    @mousewheel.prevent.native
                    style="width: 60px"
                    v-model.trim="scope.row.virtualExchangeNum"
                    size="small"
                    @input="
                      filterGt0OrFixed0('virtualExchangeNum', scope.$index)
                    "
                    clearable
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="操作"
                width="200"
              >
                <template slot-scope="scope">
                  <div v-if="type !== 'details'">
                    <el-button
                      size="small"
                      type="text"
                      @click="toFirst(scope.$index)"
                      v-if="scope.$index !== 0"
                      >置顶</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      @click="upGo(scope.$index)"
                      v-if="scope.$index !== 0"
                      >上移</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      @click="downGo(scope.$index)"
                      v-if="
                        scope.$index !== ruleForm.goodsRuleModels.length - 1 ||
                        scope.$index === 0
                      "
                      >下移</el-button
                    >

                    <el-button
                      size="small"
                      type="text"
                      v-if="
                        scope.$index !== ruleForm.goodsRuleModels.length - 1 ||
                        scope.$index === 0
                      "
                      @click="toBottom(scope.$index)"
                      >置底</el-button
                    >
                    <el-button
                      v-if="type !== 'details'"
                      size="small"
                      type="text"
                      @click="deleteChild(scope.$index)"
                      >删除</el-button
                    >
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column header-align="center" align="center" label="操作">
              <template slot-scope="scope" v-if="type !== 'details'">
                <el-button
                  size="small"
                  type="text"
                  @click="deleteChild(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column> -->
            </el-table>
          </el-form-item>

          <div id="gameAstrict">
            3.活动限制
          </div>
          <el-form-item label="主图标签文字" prop="mainTapTitle">
            <el-input
              style="width: 400px"
              size="small"
              class="mr10 ipt"
              v-model.trim="ruleForm.mainTapTitle"
              placeholder="最多8个文字"
            ></el-input>
          </el-form-item>
          <el-form-item label="弹窗文字" prop="popupTitle">
            <el-input
              style="width: 400px"
              size="small"
              class="mr10 ipt"
              v-model.trim="ruleForm.popupTitle"
              placeholder="请输入弹窗提示文字"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动限制">
            <hm-member-transfer ref="membertransfer" :showgroup="showgroup" :showtap="showtap" :showtel="showtel"> </hm-member-transfer>
          </el-form-item>
          <el-form-item label="配送方式限制" prop="expressModeGroups">
            <el-checkbox-group v-model="ruleForm.expressModeGroups">
              <el-checkbox label="shop_extract">门店自提</el-checkbox>
              <el-checkbox label="express_delivery">快递物流</el-checkbox>
            </el-checkbox-group>
            <div v-if="ruleForm.expressModeGroups.includes('shop_extract')" style="width: 100%;">
              <shop-picker
                :available-shops="availableShopList"
                :selected-shops.sync="selectedShops"
                :readonly="type === 'details'"
                @change="handleShopPickerChange"
                style="width: 100%;"
              />
            </div>
            <div v-if="ruleForm.expressModeGroups.includes('express_delivery')">
              <el-select
                size="small"
                v-model="ruleForm.expressId"
                filterable
                class="ml10"
                clearable
                placeholder="请选择运费模板"
              >
                <el-option
                  :label="v.expressName"
                  :value="v.expressId"
                  v-for="(v, i) in expressList"
                  :key="i"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-form>
        <div class="flex flex-center mt10">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >发布</el-button
          >
          <el-button size="small" @click="$router.back(-1)">返回</el-button>
        </div>
      </div>
      <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
        <div>
          <div>
            您有
            <span class="error">{{ errInputResult.length }}</span
            >条数据有误
          </div>
          <el-table :data="errInputResult" border class="small-table">
            <el-table-column
              prop="goodsSn"
              header-align="center"
              align="center"
              label="无效货号"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="specBarcode"
              label="无效条码"
            ></el-table-column>
          </el-table>
        </div>
      </el-dialog>
      <hm-filter-m-s-goods
        type="microShop"
        :visible="dialogVisible"
        :radio="isRadio"
        @saveGoods="saveGoods"
        @close="dialogVisible = false"
      ></hm-filter-m-s-goods>
      <my-upload
        field="file"
        @crop-success="cropSuccess"
        @crop-upload-success="cropUploadSuccess"
        @crop-upload-fail="cropUploadFail"
        v-model="showUploadImg"
        v-if="showUploadImg"
        noCircle
        noSquare
        :width="imgWidth"
        :height="imgHeight"
        :headers="{ 'X-Access-Token': $token }"
        :params="{ fileDir: 'goodsCenter' }"
        :url="$uploadUrl"
        img-format="png"
      ></my-upload>
    </div>
    <el-dialog
      title="设置积分商品分类"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleGoodsSettingList"
    >
      <div slot="title" class="goodsSetting">
        <span style="font-size: 18px">设置积分商品分类</span>
        <span class="form-gray ml20"
          >删除分类后所有已关联商品自动变为未设置分类</span
        >
      </div>
      <div class="table-panel flex item-center">
        <el-button type="primary" size="small" @click="addGoodsSetting"
          >添加</el-button
        >
      </div>
      <el-table
        stripe
        border
        class="mb20 mt20"
        ref="brandTable"
        :data="goodsSettingList"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="integralTypeName"
          label="积分类型名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="预览图"
          prop="previewImgPath"
          width="120"
        >
          <template slot="header">
            <el-popover
              placement="top-start"
              title="提示"
              width="200"
              trigger="hover"
              content="上传图片大小340*170，支持图片jpg、png格式"
            >
              <div slot="reference" class="flex flex-center">
                预览图
                <span>
                  <i class="el-icon-question" style="fontsize: 20px"></i>
                </span>
              </div>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.previewImgPath"
              class="img"
              :src="scope.row.previewImgPath"
              alt="logo"
              :preview-src-list="[scope.row.previewImgPath]"
            />
            <div v-else>暂无图片</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="seqNum"
          label="排序"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="listShow"
          label="首页展示状态"
        >
          <template slot="header">
            <el-popover
              placement="top-start"
              title="提示"
              width="200"
              trigger="hover"
              content="首页展示开启最多6个"
            >
              <div slot="reference" class="flex flex-center">
                首页展示状态
                <span>
                  <i class="el-icon-question" style="fontsize: 20px"></i>
                </span>
              </div>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <div class="success" v-if="scope.row.indexpageShowState === 'yes'">
              显示
            </div>
            <div class="danger" v-if="scope.row.indexpageShowState === 'no'">
              隐藏
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <div class="pointer mr10" @click="editGoods(scope.row)">
                <span class="primary">编辑</span>
              </div>
              <div class="pointer mr10" @click="removeGoods(scope.row)">
                <span class="primary">删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="close">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="integralTypeTitle"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleGoodsSetting"
    >
      <div>
        <el-form
          :model="ruleFormType"
          :rules="rulesType"
          ref="ruleFormType"
          label-width="154px"
        >
          <el-form-item label="积分类型名称" prop="integralTypeName">
            <el-input
              maxlength="8"
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormType.integralTypeName"
              placeholder="请输入积分类型名称(最多输入8个字)"
            ></el-input>
          </el-form-item>
          <el-form-item label="预览图" prop="previewImgPath">
            <div class="flex">
              <div
                class="flex goods-upload-btn"
                @click="addGoodsImg('', 'previewImgPath')"
                v-if="!ruleFormType.previewImgPath"
              >
                <div
                  style="margin-left: 0px"
                  class="btn flex flex-column flex-center open-file item-center"
                >
                  <div class="add-prize-img-wrapper">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span>添加图片</span>
                </div>
              </div>
              <div v-else class="flex item-end priviews priviews2">
                <el-image
                  class="img"
                  :src="ruleFormType.previewImgPath"
                  alt="logo"
                  :preview-src-list="[ruleFormType.previewImgPath]"
                />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button
                    type="text"
                    @click="handleRemovePrePic('previewImgPath')"
                    >删除</el-button
                  >
                </div>
              </div>
              <div class="tips ml20">
                1.上传图片大小340*170，支持图片jpg、png格式<br>
                2.首页展示状态显示时必须上传图片,
              </div>
            </div>
          </el-form-item>
          <el-form-item label="排序" prop="seqNum">
            <el-input
              maxlength="6"
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormType.seqNum"
              @input="filterGt0OrFixed3('seqNum')"
              placeholder="请输入排序"
            ></el-input>
          </el-form-item>
          <el-form-item label="首页展示状态" prop="indexpageShowState">
            <el-switch
              v-model="ruleFormType.indexpageShowState"
              active-text="显示"
              inactive-text="隐藏"
              active-value="yes"
              active-color="#13ce66"
              inactive-value="no"
            ></el-switch>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button
            size="small"
            type="primary"
            @click="saveRuleFormType('ruleFormType')"
            >{{ integralTypeText }}</el-button
          >
          <el-button size="small" @click="closeRuleFormType">取 消</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { arrayUnique2 } from "@/utils/utils";
import myUpload from "vue-image-crop-upload";
// import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
import HmMemberTransfer from "@/components/HmMemberTransfer";
// import XLSX from "xlsx";
import * as XLSX from "xlsx/xlsx";
import HmFilterMSGoods from "@/components/HmFilterMSGoods";
import { getLoginUser } from "@/utils/auth";
import Sortable from "sortablejs";
import actPreview from "@/components/actPreview";
import { ShopPicker } from "@/components/shop-picker";
import { mapGetters } from "vuex";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    myUpload,
    HmFilterMSGoods,
    HmMemberTransfer,
    actPreview,
    ShopPicker
  },
  data() {
    const expressModeGroupsStatus = (rule, val, callback) => {
      if (val.findIndex((v) => v === "shop_extract") > -1) {
        if (!this.ruleForm.shopIds.length) {
          return callback(new Error("请选择可销售门店"));
        }
      }
      if (val.findIndex((v) => v === "express_delivery") > -1) {
        if (!this.ruleForm.expressId) {
          return callback(new Error("请选择运费模板"));
        }
      }

      callback();
    };
    const patterndRuleFunc = (rule, val, callback) => {
      let falg = false;
      this.ruleForm.goodsRuleModels.forEach((v) => {
        // if(!v.bargainTotalStockSum|| v.eachPurchaseLimit||v.integralValue){

        // }
        if (!v.bargainTotalStockSum || !v.integralValue || !v.seqNum) {
          falg = true;
        }
        if (falg) {
          return callback(new Error("请输入必填项"));
        }
      });
      callback();
    };
    return {
      showgroup:true,
      showtel:false,
      showtap:false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showUploadImg: false,
      uploadType: "",
      currentGoods: {},
      selectedShops: [],
      expressList: [],
      type: this.$route.query.type,
      gameId: this.$route.query.gameId,
      isRadio: false,
      dialogVisible: false,
      errValidGoods: false,
      errInputResult: [],
      pickerOptions0: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        },
      },
      show: false,
      ruleForm: {
        activityDate: [],
        gameName: "",
        storeRegionId: "",
        gameShareContent: "",
        qrCodeState: "no",
        restrictionsShowState: "yes",
        gameBgp:
          "https://imgcdn.hemiao100.com/decoration/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20201020180656.png",
        goodsRuleModels: [],
        expressModeGroups: [],
        shopIds: [],
        expressId: "",
        popupTitle:"",
        mainTapTitle:""
      },
      rules: {
        gameName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur",
          },
          {
            min: 2,
            max: 30,
            message: "长度在 2 到 30 个字符",
            trigger: "blur",
          },
        ],
        gameShareContent: [
          {
            required: true,
            message: "请输入活动分享文案",
            trigger: "blur",
          },
        ],
        gameBgp: {
          required: true,
          message: "请选择图片！",
          trigger: "blur",
        },
        activityDate: {
          required: true,
          message: "请选择活动时间",
          trigger: "blur",
        },
        mainTapTitle:[
          {
            required: true,
            message: "请输入主图标签文字",
            trigger: "blur",
          },
          {
            max: 8,
            message: "长度在 8 个字符内",
            trigger: "blur",
          },
        ],
        popupTitle:[
          {
            required: true,
            message: "请输入弹窗提示文字",
            trigger: "blur",
          },
          {
            max: 32,
            message: "长度在 32 个字符内",
            trigger: "blur",
          },
        ],
        goodsRuleModels: [
          {
            required: true,
            message: "请设置规则！",
            trigger: "blur",
          },
          {
            required: true,
            validator: patterndRuleFunc,
            trigger: "blur",
          },
        ],
        expressModeGroups: [
          {
            required: true,
            message: "请选择配送方式限制",
          },
          {
            required: true,
            validator: expressModeGroupsStatus,
          },
        ],
      },
      rowSpanArr: [],
      regionList: [],
      updateMode: "",
      dialogVisibleGoodsSettingList: false,
      goodsSettingList: [],
      typeName: "",
      imgWidth: 0,
      imgHeight: 0,
      dialogVisibleGoodsSetting: false,
      integralType: "add",
      integralTypeTitle: "新增积分类型",
      integralTypeText: "新 增",
      newIntegralExchangeState: "",
      storeCode: "",
      ruleFormType: {
        integralTypeName: "",
        previewImgPath: "",
        seqNum: "",
        indexpageShowState: "no",
      },
      rulesType: {
        integralTypeName: [
          {
            required: true,
            message: "请输入积分类型名称",
            trigger: "blur",
          },
        ],
        seqNum: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    availableShopList: {
      handler(newList) {
        if (newList && newList.length > 0 && this.ruleForm.shopIds && this.ruleForm.shopIds.length > 0) {
          this.setSelectedShops();
        }
      },
      immediate: true
    }
  },
  created() {
    this.queryExpressList();
  },
  mounted() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    console.log("this.storeCode:",this.storeCode);
    if (storeCode === '42010216070190' || storeCode === '53010017032439') {
      this.$store.dispatch("queryDkMicroStoreList");
    } else {
      this.$store.dispatch("queryMicroStoreList");
    }
    this.queryStoreConfigAll();
    this.queryRegionList();
    if (this.type) {
      this.queryDetails();
    }
    this.queryWxshopSpuIntegralTypeInfoList();
    this.rowDrop();
    this.$store.dispatch("queryStoreStyle");
  },
  computed: {
    ...mapGetters(["storeStyle", "microShopStoreList", "dkMicroShopStoreList"]),
    availableShopList() {
      if (this.storeCode === '53010017032439' || this.storeCode === '42010216070190') {
        return this.dkMicroShopStoreList || [];
      }
      return this.microShopStoreList || [];
    }
  },
  methods: {

    // 运费模板
    async queryExpressList() {
      const { result } = await this.$store.dispatch("storeExpressConfigList");
      this.expressList = [];
      if (result.defaultTemplate) {
        this.expressList.push(result.defaultTemplate);
      }
      this.expressList.push(...result.templateList);
    },
    async queryRegionList() {
      const { result } = await this.$store.dispatch("storeRegionQueryPageList", {
        pageSize: 999,
        pageNo: 1
      });
      this.regionList = result.records || [];
    },
    handleShopPickerChange(shops) {
      this.ruleForm.shopIds = shops.map(s => s.shopId || s.id);
    },
    setSelectedShops() {
      const shopIds = this.ruleForm.shopIds || [];
      const availableShops = this.availableShopList || [];
      if (shopIds.length === 1 && shopIds[0] === 'all') {
        this.selectedShops = [...availableShops];
      } else if (shopIds.length > 0) {
        this.selectedShops = shopIds.map(shopId => {
          const shop = availableShops.find(s => (s.shopId || s.id) === shopId);
          return shop || { shopId: shopId, shopName: shopId };
        }).filter(s => s);
      } else {
        this.selectedShops = [];
      }
    },
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        handle: ".my-handle",
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.ruleForm.goodsRuleModels.splice(oldIndex, 1)[0];
          _this.ruleForm.goodsRuleModels.splice(newIndex, 0, currRow);
        },
      });
    },
    async queryDetails() {
      const { result } = await this.$store.dispatch("queryActivitDetail", {
        gameId: this.gameId,
      });
      result.expressModeGroups = result.expressModeGroups || [];
      result.shopIds = result.shopIds || [];
      for (let key in this.ruleForm) {
        this.ruleForm[key] = result[key];
      }
      this.ruleForm.activityDate = [result.gameStartTime, result.gameEndTime];
      this.setSelectedShops();
      this.ruleForm.goodsRuleModels.forEach((v) => {
        v.wxshopSpuName = v.goodsName;
      });
      setTimeout(() => {
        console.log("result----",result);
        this.$refs.membertransfer.rightData = result.memberThresholdInfoModels;
        this.$refs.membertransfer.rightChecked =
          result.memberThresholdInfoModels;
      }, 100);
      this.updateMode = result.updateMode;
    },
    filterGt0OrFixed0(prop, i) {
      if (prop !== "integralPrice" && prop !== "virtualExchangeNum" && prop !== "seqNum") {
        this.ruleForm.goodsRuleModels[i][prop] = this.ruleForm.goodsRuleModels[
          i
        ][prop].replace(/^(0+)/, ""); //过滤0开头
      }

      this.ruleForm.goodsRuleModels[i][prop] = this.ruleForm.goodsRuleModels[i][
        prop
      ].replace(/[^\d]+/g, "");
      this.ruleForm.goodsRuleModels[i][prop] = this.ruleForm.goodsRuleModels[i][
        prop
      ].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    saveGoods(data) {
      if (data.length > 0) {
        this.dialogVisible = false;
        this.ruleForm.goodsRuleModels.push(...data);
        this.ruleForm.goodsRuleModels = arrayUnique2(
          this.ruleForm.goodsRuleModels,
          "wxshopSkuId"
        );
      } else {
        this.$message({
          message: "请选择商品",
          type: "warning",
        });
      }
    },
    addGoods() {
      this.dialogVisible = true;
    },
    toFirst(index) {
      if (index != 0) {
        // this.ruleForm.goodsRuleModels[index] = this.ruleForm.goodsRuleModels.splice(0, 1, this.ruleForm.goodsRuleModels[index])[0]; 这种方法是与另一个元素交换了位子，

        this.ruleForm.goodsRuleModels.unshift(
          this.ruleForm.goodsRuleModels.splice(index, 1)[0]
        );
      }
    },
    upGo(index) {
      if (index != 0) {
        this.ruleForm.goodsRuleModels[index] =
          this.ruleForm.goodsRuleModels.splice(
            index - 1,
            1,
            this.ruleForm.goodsRuleModels[index]
          )[0];
      } else {
        this.ruleForm.goodsRuleModels.push(
          this.ruleForm.goodsRuleModels.shift()
        );
      }
    },
    downGo(index) {
      if (index != this.ruleForm.goodsRuleModels.length - 1) {
        this.ruleForm.goodsRuleModels[index] =
          this.ruleForm.goodsRuleModels.splice(
            index + 1,
            1,
            this.ruleForm.goodsRuleModels[index]
          )[0];
      } else {
        this.ruleForm.goodsRuleModels.unshift(
          this.ruleForm.goodsRuleModels.splice(index, 1)[0]
        );
      }
    },
    swapArr(index1) {
      this.ruleForm.goodsRuleModels[index1] =
        this.ruleForm.goodsRuleModels.splice(
          this.ruleForm.goodsRuleModels.length - 1,
          1,
          this.ruleForm.goodsRuleModels[index1]
        )[0];
    },

    toBottom(index) {
      let temp;
      if (index >= this.ruleForm.goodsRuleModels.length - 1 || index < 0) {
        return this.ruleForm.goodsRuleModels;
      }
      temp = this.ruleForm.goodsRuleModels[index];
      this.ruleForm.goodsRuleModels.push(temp);
      this.ruleForm.goodsRuleModels.splice(index, 1);
      return this.ruleForm.goodsRuleModels;
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "商品货号",
          "商品条码",
          "活动库存(若为读取则可不填)",
          "单人限购",
          "兑换价值(积分)",
          "兑换价值(元)",
          "虚拟兑换人数",
        ];
        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        exportJsonToExcel(tHeader, data, "导入模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        // const formatResult = [];
        // let isValid = true;
        // let isRequired = true;
        // let goodsSns = [];
        let goodsSnsAndSpecBarcode = [];
        result.forEach((v) => {
          // if (v[0]) {
          //   goodsSns.push(v[0]);
          // }
          if (v[0] || v[1]) {
            goodsSnsAndSpecBarcode.push({
              goodsSn: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              specBarcode: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
              bargainTotalStockSum: v[2] ? (v[2] + "").replace(/\s*/g, "") : "",
              eachPurchaseLimit: v[3] ? (v[3] + "").replace(/\s*/g, "") : "",
              integralValue: v[4] ? (v[4] + "").replace(/\s*/g, "") : "",
              integralPrice: v[5] ? (v[5] + "").replace(/\s*/g, "") : "",
              virtualExchangeNum: v[6] ? (v[6] + "").replace(/\s*/g, "") : "",
            });
          }
        });

        // goodsSns = unique(goodsSns);
        that.$store
          .dispatch("queryWxshopSkuByGoodsSn", { goodsSnsAndSpecBarcode })
          .then((res) => {
            const { code, result } = res;
            if (code === "0") {
              if (result.modelList.length > 0) {
                // result.modelList.forEach(v => {
                //   v.bargainTotalStockSum = "";
                //   v.eachPurchaseLimit = "";
                //   v.integralValue = "";
                // });
                that.ruleForm.goodsRuleModels.push(...result.modelList);
                that.ruleForm.goodsRuleModels = arrayUnique2(
                  that.ruleForm.goodsRuleModels,
                  "wxshopSkuId"
                );
                that.$forceUpdate();
                // that.distributionGoodList = [];
                // result.modelList.forEach(v => {
                //   formatResult.forEach(item => {
                //     if (v.goodsSn === item.goodsSn) {
                //       that.distributionGoodList.push(
                //         Object.assign({}, item, v)
                //       );
                //     }
                //   });
                // });
              }
              if (result.errGoodsSnsAndSpecBarcode.length > 0) {
                that.errValidGoods = true;
                that.errInputResult = result.errGoodsSnsAndSpecBarcode;
                // result.errGoodsSnsAndSpecBarcode.forEach(v => {
                //   that.errInputResult.push({ goodsSn: v });
                // });
              }
            }
          });
        // result.forEach(v => {
        //   if (!v[0] || !v[1] || !v[2]) {
        //     isRequired = false;
        //   } else {
        //     if (!that.isString(v[1]) || !that.isString(v[2])) {
        //       isValid = false;
        //       //   that.errValidGoods = true;
        //       //   that.errInputResult.push({
        //       //     name: v[0],
        //       //     mobile: v[1]
        //       //   });
        //     } else {
        //       goodsSns.push(v[0]);
        //       formatResult.push({
        //         goodsSn: v[0] + "",
        //         commissionStartTime: `${v[1]} 00:00:00`,
        //         commissionEndTime: `${v[2]} 23:59:59`,
        //         commissionType:
        //           v[3] === "固定返佣" ? "fixedReturn" : "ratioReturn",
        //         commissionValue: v[4] ? v[4] : "",
        //         agentDiscountValue: v[5] ? v[5] : ""
        //       });
        //     }
        //   }
        // });
        // if (isValid && isRequired) {
        //   let errList = formatResult.filter((item, index, self) => {
        //     for (let i = index + 1; i < self.length; i++) {
        //       if (self[i].goodsSn === item.goodsSn) {
        //         return true;
        //       }
        //     }
        //     return false;
        //   });

        //   if (errList.length > 0) {
        //     that.errValidGoods = true;
        //     that.errInputResult = errList;
        //     that.$message({
        //       message: "导入失败，有重复商品货号！",
        //       type: "warning"
        //     });
        //   } else {
        //     that.$store
        //       .dispatch("queryShareGoodsSn", { goodsSns })
        //       .then(res => {
        //         const { code, result } = res;
        //         if (code === "0") {
        //           if (result.resultList.length > 0) {
        //             that.distributionGoodList = [];
        //             result.resultList.forEach(v => {
        //               formatResult.forEach(item => {
        //                 if (v.goodsSn === item.goodsSn) {
        //                   that.distributionGoodList.push(
        //                     Object.assign({}, item, v)
        //                   );
        //                 }
        //               });
        //             });
        //           }
        //           if (result.errGoodsSns.length > 0) {
        //             that.errValidGoods = true;
        //             that.errInputResult = [];
        //             result.errGoodsSns.forEach(v => {
        //               that.errInputResult.push({ goodsSn: v });
        //             });
        //           }
        //         }
        //       });
        //   }
        // } else {
        //   if (!isRequired) {
        //     that.$message({
        //       message: "导入失败，请导入必填商品信息！",
        //       type: "warning"
        //     });
        //   } else if (!isValid) {
        //     that.$message({
        //       message: "导入失败，日期请使用文本格式导入！",
        //       type: "warning"
        //     });
        //   }
        // }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    isString(value) {
      return typeof value === "string";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    addChild() {
      this.ruleForm.goodsRuleModels.push({});
    },
    deleteChild(index) {
      this.ruleForm.goodsRuleModels.splice(index, 1);
    },
    getRowSpan() {
      this.rowSpanArr = [];
      this.ruleForm.goodsRuleModels.forEach((item, index) => {
        if (index == 0) {
          this.rowSpanArr.push(1);
          this.position = 0;
        } else {
          if (
            this.ruleForm.goodsRuleModels[index].goodsSn ==
            this.ruleForm.goodsRuleModels[index - 1].goodsSn
          ) {
            this.rowSpanArr[this.position] += 1; //项目名称相同，合并到同一个数组中
            this.rowSpanArr.push(0);
            this.ruleForm.goodsRuleModels[index].goodsSn =
              this.ruleForm.goodsRuleModels[index - 1].goodsSn;
          } else {
            this.rowSpanArr.push(1);
            this.position = index;
          }
        }
      });
    },

    handleRemove() {
      this.ruleForm.gameBgp = "";
    },
    handleRemovePrePic(index, type) {
      if (type === "prePic") {
        this.$set(this.ruleForm.goodsRuleModels[index], "prePic", "");
      }
      if (type === "previewImgPath") {
        this.ruleFormType.previewImgPath = "";
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.uploadType === "prePic") {
        this.currentGoods.prePic = jsonData.result;
        this.ruleForm.goodsRuleModels.forEach((v) => {
          if (v.skuId === this.currentGoods.skuId) {
            v.prePic = this.currentGoods.prePic;
          }
        });
        this.ruleForm.goodsRuleModels = JSON.parse(
          JSON.stringify(this.ruleForm.goodsRuleModels)
        );
        console.log("this.currentGoods: ", this.currentGoods);
        return;
      }
      if (this.uploadType === "previewImgPath") {
        this.ruleFormType.previewImgPath = jsonData.result;
      }
      if (this.show) {
        this.ruleForm.gameBgp = jsonData.result;
      }
    },
    filterGt0OrFixed2(prop, i) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.goodsRuleModels[i][prop] = this.ruleForm.goodsRuleModels[i][
        prop
      ].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm.goodsRuleModels[i][prop] = this.ruleForm.goodsRuleModels[i][
        prop
      ].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm.goodsRuleModels[i][prop] = this.ruleForm.goodsRuleModels[i][
        prop
      ]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm.goodsRuleModels[i][prop] = this.ruleForm.goodsRuleModels[i][
        prop
      ].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (
        this.ruleForm.goodsRuleModels[i][prop].indexOf(".") < 0 &&
        this.ruleForm.goodsRuleModels[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleForm.goodsRuleModels[i][prop] = parseFloat(
          this.ruleForm.goodsRuleModels[i][prop]
        );
      }
    },
    filterGt0OrFixed3(prop) {
      // this.ruleFormType[prop] = this.ruleFormType[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleFormType[prop] = this.ruleFormType[prop].replace(/[^\d]/g, ""); //仅保留数字和"."
      this.ruleFormType[prop] = this.ruleFormType[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleFormType[prop] = this.ruleFormType[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleFormType[prop]= this.ruleFormType[prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (
        this.ruleFormType[prop].indexOf(".") < 0 &&
        this.ruleFormType[prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleFormType[prop] = parseFloat(
          this.ruleFormType[prop]
        );
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          params.gameStartTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[0]
              : "";
          params.gameEndTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[1]
              : "";
          params.gameType = "integral_exchange";
          params.goodsRuleModels.forEach((v) => {
            v.goodsName = v.wxshopSpuName;
          });
          // params.goodsRuleModels.forEach(v => {
          //   if (!v.eachPurchaseLimit) {
          //     v.eachPurchaseLimit = ;
          //   }
          // });
          params.memberThresholdInfoModels = this.$refs.membertransfer.rightData;
          let name = this.type === "details" ? "editActivity" : "addTurntable";
          params.gameId = this.gameId;
          params.updateMode = this.updateMode;
          console.log("this.type", this.type);
          if (this.type === "details") {
            params.isLook = "yes";
          } else {
            params.isLook = "no";
          }

          if (this.type === "edit") {
            this.$store.dispatch("editGameInfoJieLong", params).then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.$router.back(-1);
              } else {
                this.$message({
                  message: res.errMsg,
                  type: "warning",
                });
              }
            });
          } else {
            this.$store.dispatch(name, params).then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.$router.back(-1);
              } else {
                this.$message({
                  message: res.errMsg,
                  type: "warning",
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    addGoodsImg(v, type) {
      this.uploadType = type;
      switch (this.uploadType) {
        case "prePic":
          this.imgWidth = 750;
          this.imgHeight = 750;
          break;
        case "previewImgPath":
          this.imgWidth = 340;
          this.imgHeight = 170;
          break;
        default:
          this.imgWidth = 750;
          this.imgHeight = 1334;
          break;
      }
      this.currentGoods = v;
      this.showUploadImg = true;
    },
    openGoodsSetting() {
      this.dialogVisibleGoodsSettingList = true;
      this.queryWxshopSpuIntegralTypeInfoList();
    },
    addGoodsSetting() {
      this.integralType = "add";
      this.integralTypeText = "新 增";
      this.integralTypeTitle = "新增积分类型";
      this.ruleFormType = {
        integralTypeName: "",
        previewImgPath: "",
        seqNum: "",
        indexpageShowState: "no",
      };
      this.dialogVisibleGoodsSetting = true;
    },
    async editGoods(row) {
      this.integralType = "edit";
      this.integralTypeText = "保 存";
      this.integralTypeTitle = "编辑积分类型";
      let params = {
        id: row.id,
      };
      const { result } = await this.$store.dispatch(
        "wxshopSpuIntegralTypeInfoQueryById",
        params
      );
      this.ruleFormType = result;
      this.dialogVisibleGoodsSetting = true;
    },
    async removeGoods(row) {
      let params = {
        id: row.id,
      };
      const { result } = await this.$store.dispatch(
        "wxshopSpuIntegralTypeInfoQueryById",
        params
      );
      console.log("result:", result);
      if (result) {
        if (result.useCount > 0) {
            let useCount = result.useCount;
            const result2 = await this.$confirm("此类型已绑定"+ useCount +"个商品,是否删除本条数据?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            });
            if (result2 === "confirm") {
              this.deleteGoods(row);
            }
        }else{
          this.deleteGoods(row);
        }
      }
    },
    async deleteGoods(row) {
      let params = {
        id: row.id,
      };
      const { code } = await this.$store.dispatch(
        "wxshopSpuIntegralTypeInfoDelete",
        params
      );
      if (code === "0") {
        this.queryWxshopSpuIntegralTypeInfoList();
      }
    },
    save() {
      this.dialogVisibleGoodsSettingList = false;
    },
    close() {
      this.dialogVisibleGoodsSettingList = false;
    },
    saveRuleFormType(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (
            this.ruleFormType.indexpageShowState === "yes" &&
            !this.ruleFormType.previewImgPath
          ) {
            this.$message({
              message: "如果在首页展示,请先上传预览图",
              type: "warning",
            });
            return;
          }
          let params = JSON.parse(JSON.stringify(this.ruleFormType));
          let url;
          if (this.integralType === "add") {
            url = "wxshopSpuIntegralTypeInfoAdd";
          } else if (this.integralType === "edit") {
            url = "wxshopSpuIntegralTypeInfoEdit";
          }
          this.$store.dispatch(url, params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.dialogVisibleGoodsSetting = false;
              this.queryWxshopSpuIntegralTypeInfoList();
            }
          });
        }
      });
    },
    closeRuleFormType() {
      this.dialogVisibleGoodsSetting = false;
    },
    async queryWxshopSpuIntegralTypeInfoList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      };
      const { result } = await this.$store.dispatch(
        "wxshopSpuIntegralTypeInfoList",
        params
      );
      const { records, total } = result;
      this.goodsSettingList = records;
      this.total = total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryWxshopSpuIntegralTypeInfoList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryWxshopSpuIntegralTypeInfoList();
    },
    async queryStoreConfigAll() {
      const { storeCode } = getLoginUser();
      this.storeCode = storeCode;
      const { result } = await this.$store.dispatch("queryStoreConfigAll", {
        storeCode: this.storeCode,
        code: "newIntegralExchange",
      });
      console.log("result:", result);
      if (result.value) {
        this.newIntegralExchangeState = result.value;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.priview {
  position: relative;
  width: 400px;
  height: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.act-container {
  max-width: 2000px;
  overflow-x: auto;
  .step-wrapper {
    border-bottom: none !important;
    margin-bottom: 0;
  }
  .add-goods-containers {
    width: 1128px;
    flex-shrink: 0;
  }
  .slot {
    .header-img-wrapper {
      box-sizing: border-box;
      .header-img {
        width: 100%;
        display: block;
      }
    }
    .redeem-upload {
      > .upload-img {
        top: 90px;
      }
    }
    .empty {
      margin-top: 30px;
      text-align: center;
    }

    strong {
      font-size: 16px;
    }

    .preview-goods-list {
      padding: 15px;
      font-size: 12px;
      &:hover {
        .add-goods {
          display: block;
          position: absolute;
          cursor: pointer;
          display: none;
          top: 0;
          left: 0;
          z-index: 9030;
          zoom: 1;
          width: 34px;
          height: 34px;
          font-size: 12px;
          background-color: rgba(0, 0, 0, 0.8);
          border: 1px solid #fff;
          border-radius: 4px;
          text-align: center;
          line-height: 34px;
        }
      }
      .add-goods {
        position: absolute;
        top: 0;
        left: 0;
        display: none;
      }
      .goods-item {
        position: relative;
        background: #fff;
        margin-bottom: 10px;
        padding: 10px;
        border-radius: 5px;
        &:hover {
          .delete-item {
            display: block;
          }
        }
        .img-wrapper {
          width: 110px;
          height: 100px;
          margin-right: 10px;
          img {
            width: 100%;
            border-radius: 4px;
          }
        }

        .goods-name {
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .tag {
          font-size: 12px;
          padding: 0 5px;
          color: #fff;
          border-radius: 30px;
        }
        .origin-price {
          color: #999;
          margin-top: 8px;
          text-decoration: line-through;
        }
      }
    }
  }
  .progress-wrapper {
    margin-bottom: 5px;

    .progress {
      position: relative;
      width: 110px;
      border-radius: 30px;
      overflow: hidden;
      height: 13px;
      line-height: 13px;
      .slide {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        height: 100%;
        border-radius: 30px;
      }
    }
    .progress-info {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      height: 100%;
      z-index: 1;
      font-size: 10px;
      width: 100%;
      box-sizing: border-box;
      padding: 0 5px;
      color: #fff;
    }
    .percent {
      font-size: 12px;
      margin-left: 10px;
    }
  }
}
.wadwa:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
.goods-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .logo {
    width: 80px;
    height: 80px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
        margin-right: 0 !important;
      }
    }
  }
}
.add-prize-img-wrapper {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  user-select: none;
  text-align: center;
  .hmicon {
    font-size: 14px;
    margin-right: 0px;
  }
}
.priviews {
  position: relative;
  width: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 0;
  padding: 0;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.goodsSetting {
  line-height: 40px;
  border-bottom: 1px solid #dddddd;
  .form-gray {
    color: #aaaaaa;
  }
}
.preview-type-list {
  width: 100%;
  .type-title {
    text-indent: 10px;
    line-height: 32px;
  }
  .type-item {
    display: inline-block;
    width: 166px;
    height: 83px;
    margin: 6px;
    .img {
      width: 100%;
      height: 100%;
    }
  }
}
.priviews2 {
  width: 170px;
}
</style>
